import { BottomSpace } from './BottomSpace';
import { Divider } from './Divider';
import { MenuItem } from './MenuItem';
import { SubMenuProdGuide } from './submenu/SubMenuProdGuide';
import useMenuUrl, { MenuItemWrap } from './useMenuUrl';
import { useState } from 'react';
import { useLoginInfo } from 'hooks/useLoginInfo';
import { loginutil } from 'util/loginutil';

export const MainMenuUs = ({ onClose, onClickAiChatbot }: { onClose: () => void; onClickAiChatbot?: () => void }) => {
  const { getMenuUrl, menuEnabled } = useMenuUrl({ type: 'menu' });
  const [showMenuProdGuide, setShowMenuProdGuide] = useState(false);
  const loginInfo = useLoginInfo();
  return (
    <>
      {onClickAiChatbot && (
        <MenuItemWrap
          menuId="ai-chatbot"
          onClick={(e: React.MouseEvent<HTMLElement>) => {
            e.preventDefault();
            e.stopPropagation();
            onClickAiChatbot();
          }}
          type="menu"
        />
      )}
      <MenuItemWrap menuId="dlcenter" onClick={onClose} type="menu" />
      <MenuItemWrap menuId="knowledge" onClick={onClose} type="menu" />
      <MenuItemWrap menuId="sample" onClick={onClose} type="menu" />

      <Divider />
      <MenuItemWrap menuId="test-report" onClick={onClose} type="menu" />

      <Divider />
      {menuEnabled('asset-insight') && <MenuItemWrap menuId="asset-insight" onClick={onClose} type="menu" />}
      {menuEnabled('energy-simul') && <MenuItemWrap menuId="energy-simul" onClick={onClose} type="menu" />}

      {/* <MenuItemWrap menuId="remote" onClick={onClose} type="menu" /> */}
      <MenuItem
        label={getMenuUrl('prod-selector').label}
        onClick={() => setShowMenuProdGuide(!showMenuProdGuide)}
        isSubMenu
        showSubMenu={showMenuProdGuide}
      />
      {showMenuProdGuide && <SubMenuProdGuide onClose={onClose} />}
      <Divider />
      <MenuItemWrap menuId="ls-electric-america" onClick={onClose} type="menu" />
      <MenuItemWrap menuId="ls-electric-global" onClick={onClose} type="menu" />

      <Divider />
      <MenuItemWrap menuId="news-event" onClick={onClose} type="menu" />
      <BottomSpace />
      <div style={{ flex: 1 }}></div>
    </>
  );
};
